import enrollmentStudentAttachmentAPI from '@/apis/business/enrollmentStudentAttachmentAPI'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('EnrollmentStudentAttachment', enrollmentStudentAttachmentAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
  },
  mutations: {
    ...crudBase.mutations,
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,
  },
}
